interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description?: string;
}

export function PageHeader({
  eyebrow,
  title,
  description,
}: PageHeaderProps) {
  return (
    <header className="border-b border-zinc-800 pb-7">
      <p className="mb-4 font-mono text-[9px] font-semibold tracking-[0.24em] text-zinc-500">
        {eyebrow}
      </p>
      <h1 className="max-w-4xl text-balance text-[30px] font-light uppercase tracking-[-0.035em] text-zinc-100 sm:text-[44px] lg:text-[60px]">
        {title}
      </h1>
      {description ? (
        <p className="mt-5 max-w-2xl text-sm font-light leading-7 text-zinc-400 sm:text-base">
          {description}
        </p>
      ) : null}
    </header>
  );
}
